import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

class RiskList extends Component {

    constructor(props){
        super(props)
    }
    render() {
        let x = 0
        let listItems = [].concat(this.props.content.RiskFactors)
        .sort((a, b) => parseInt(a.Order) > parseInt(b.Order) ? 1 : -1)
        .map((item) => {
            if(item.Visibility=="1"){
                return <li>{item.Content}</li>
            }
        })
        .filter((item) => {
            if(item){
                return true
            } else return false
        })
        if(listItems.length>this.props.content.RiskFactorMaxItems){
            listItems = listItems.slice(0,this.props.content.RiskFactorMaxItems)
        }
        return(
            <Grid style={{textAlign:'left', marginTop:'20px'}}>
                <Typography>{this.props.content.RiskFactorText}</Typography>
                <ul style={{marginTop:'0px'}}>
                    {listItems}
                </ul>
            </Grid>
        )
    }
}

export default RiskList

/* 
{
            "ComponentClass": "RISKFACTOR",
            "ComponentFamily": "",
            "ComponentType": "LIST",
            "ComponentVisible": "",
            "ComponentContent": {
                "RiskFactorText": "Your risk level is based on things you reported. Some of your greatest risk factors are:",
                "RiskFactorMaxItems": "3",
                "RiskFactors": [
                    {
                        "Content": "Having a family history of breast cancer",
                        "Visibility": "1",
                        "Order": "1"
                    },
                    {
                        "Content": "Having dense breasts",
                        "Visibility": "1",
                        "Order": "3"
                    },
                    {
                        "Content": "Having your first child after you were 30 years old",
                        "Visibility": "1",
                        "Order": "1"
                    },
                    {
                        "Content": "Je n'sai quoi",
                        "Visibility": "1",
                        "Order": "5"
                    },
                    {
                        "Content": "",
                        "Visibility": "",
                        "Order": ""
                    },
*/